import { Component, Input, inject } from '@angular/core';
import { RouterDataService } from '@services/router-data.service';
import { RouterService } from '@services/router.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-student-heading-bar',
  templateUrl: './student-heading-bar.component.html',
  styleUrls: ['./student-heading-bar.component.scss'],
  standalone: false,
})
export class StudentHeadingBarComponent {
  routerDataService = inject(RouterDataService);
  private routerService = inject(RouterService);

  @Input() dataConfirm: Subject<string>;

  onBack() {
    this.routerService.goBack(this.dataConfirm);
  }
}
